import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { addVehicleToCareServiceFleet as _addVehicleToCareServiceFleet } from '../../../actions/vehicleActions';
import { fetchCareServices as _fetchCareServices } from '../../../actions/careServiceActions';
import { getStyle } from '../../../utils/utils';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBModal from '../../shared/CBModal';
import CBSelectField from '../../shared/form_components/CBSelectField';

// The fleet joins its own machine to one of its workshop care services, on the
// workshop's behalf, so the workshop does not have to link it by identifier.
class AddToCareServiceModal extends Component {
  state = {
    careServiceId: '',
    suggested: false,
  };

  componentDidMount = () => {
    const { fetchCareServices, selectedOrganizationId } = this.props;
    fetchCareServices({ organization_id: selectedOrganizationId });
  };

  componentDidUpdate = () => {
    // The API middleware resolves .then() with undefined: suggest the single
    // care service once the list lands in the store.
    const { suggested } = this.state;
    const careServices = this.getOrganizationCareServices();
    if (!suggested && careServices.length) {
      this.setState({
        suggested: true,
        careServiceId: careServices.length === 1 ? String(careServices[0].id) : '',
      });
    }
  };

  getOrganizationCareServices = () => {
    const { careServices, selectedOrganizationId } = this.props;
    return (careServices || []).filter((careService) => (
      careService.organization && careService.organization.id == selectedOrganizationId && careService.workshop
    ));
  };

  submitForm = () => {
    const {
      closeModal, vehicle, selectedOrganizationId, addVehicleToCareServiceFleet,
    } = this.props;
    addVehicleToCareServiceFleet(vehicle.id, Number(this.state.careServiceId), selectedOrganizationId);
    closeModal();
  };

  render() {
    const {
      modalIsOpen, afterOpenModal, closeModal, t, vehicle,
    } = this.props;
    const { careServiceId } = this.state;
    const careServices = this.getOrganizationCareServices();

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            afterOpenModal={afterOpenModal}
            closeModal={closeModal}
            title={t('attachToCareServiceTitle')}
            descriptionText={t('attachToCareServiceDescription')}
            cancelText={t('cancel')}
            submitText={t('attachToCareService')}
            vehicleText={vehicle.registration_number}
            submitForm={this.submitForm}
            isValid={!!careServiceId}
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              {careServices.length ? (
                <CBSelectField
                  name='careService'
                  labelText={t('equipmentCareServiceLabel')}
                  labelTextStyle={getStyle(screenSize, styles, 'selectLabel')}
                  inputStyle={getStyle(screenSize, styles, 'select')}
                  value={careServiceId}
                  options={[{ label: t('noCareServiceOption'), value: '' }].concat(
                    careServices.map((careService) => (
                      { label: careService.workshop.name, value: String(careService.id) }
                    )),
                  )}
                  onChange={(changed) => this.setState({ careServiceId: changed.value })}
                />
              ) : (
                <p style={getStyle(screenSize, styles, 'info')}>{t('noCareServicesAvailable')}</p>
              )}
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 32px',
      gap: 16,
    },
    selectLabel: {
      fontSize: 14,
      color: 'black',
      textAlign: 'center',
      fontWeight: 'bold',
    },
    select: {
      width: '100%',
      backgroundColor: '#ebebeb',
      color: 'black',
      border: 'none',
      borderRadius: 100,
      height: 40,
      fontSize: 14,
      textAlign: 'center',
    },
    info: {
      fontSize: 14,
      color: 'black',
      textAlign: 'center',
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px',
    },
  },
};

function mapStateToProps(state) {
  return {
    selectedOrganizationId: state.organization.selectedOrganization,
    careServices: state.careService.careServices,
  };
}

export default connect(
  mapStateToProps,
  {
    addVehicleToCareServiceFleet: _addVehicleToCareServiceFleet,
    fetchCareServices: _fetchCareServices,
  },
)(translate('GarageView')(AddToCareServiceModal));
